import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const onfleet = defineConnector({
  identifier: "onfleet",
  name: "Onfleet",
  tagLine: "Delivery management",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://onfleet\\.com/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Onfleet](https://onfleet.com/), go to **Settings → API & Webhooks** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://onfleet.com/api/v2/organization",
  },
});
